<template>
  <section class="common-box">
    <section class="position-box">{{navdata.navigationName}}</section>
    <el-carousel  trigger="click"
                  height="555px"
                  arrow="never"
                  :autoplay="autoplay"
                  :interval="interval"
                  :initial-index="initialIndex">
      <el-carousel-item v-for="(item,index) in bannerList" :key="index" 
        v-if="bannerList.length">
        <div class="swiper-box">
          
          <div class="swiper-main" :style="{background: bgColor ? bgColor : '#B1CECC'}">
            <p class="swiper-title">{{item.contentTitleEn}}</p>
            <p class="swiper-sub-title">{{item.contentTitle}}</p>
            <p class="sort-line"></p>
            <p class="swiper-desc">{{item.contentDesc}}</p>

            <router-link class="more-button"
                          :to="{
                            name: 'detail',
                            query: {
                              parentPrimaryKey: $route.query.primaryKey,
                              primaryKey: item.primaryKey
                            }
                          }"><p>MORE</p> <span>></span></router-link>
          </div>
          <img :src="item.contentImgUrl" class="banner-img"/>
        </div>
      </el-carousel-item>
      <el-carousel-item 
        v-if="!bannerList.length">
        <div class="null-box">
          暂无相关咨讯
        </div>
      </el-carousel-item>
    </el-carousel>
  </section>
</template>
<script>
  export default {
  props: ['bannerList', 'bgColor','navdata'],
  data () {
    return {
      autoplay: true,
      interval: 3000,
      initialIndex: 0,
    }
  },
}
</script>

<style lang="scss">
.el-carousel__container {
  .el-carousel__arrow {
    background: rgba(255, 255, 255, 0.1);
  }
}
.el-carousel__indicators {
  left: 60px;
  bottom: 50px;
  transform: translateX(0);

  .el-carousel__indicator {
    width: 48px;
    margin: 0 6px;
    padding: 0;

    .el-carousel__button {
      height: 5px;
      width: 48px;
      opacity: 1;
    }
  }
  .is-active {
    .el-carousel__button {
      background: #B1CECC;
    }
  }
}

.common-box {
  position: relative;
  height: 100%;
  .position-box {
    position: absolute;
    top: 30px;
    left: -40px;
    width: 210px;
    height: 115px;
    background: #f1d9b0;
    color: #B1CECC;
    font-size: 33px;
    text-align: center;
    line-height: 115px;
    z-index: 4;
    box-shadow: 2px 4px 6px rgba(0,0,0,0.2)
  }

  .null-box {
    font-size: 24px;
    color: #fff;
  }
  .el-carousel {
    height: 100%;
  }
  .el-carousel__container {
    height: 100%!important;
  }

  .swiper-box {
    width: 100%;
    height: 100%;
    position: relative;

    .banner-img {
      width: 100%;
      height: 100%;
    }
    .swiper-main {
      height: 100%;
      width: 60%;
      position: absolute;
      top: 0;
      right: 0;
      color: #fff;
      padding-left: 47px;

      .content-item-title {
        font-size: 33px;
        margin-top: 50px;
      }

      .swiper-title {
        font-size: 18px;
        margin-top: 87px;
      }

      .sort-line {
        margin-top: 75px;
        width: 50px;
        height: 1px;
        background: #f1d9b0;
      }

      .swiper-sub-title {
        margin-top: 20px;
        font-size: 33px;
      }

      .swiper-desc {
        margin: 25px 20px 0 0;
        font-size: 18px;
        line-height: 24px;
        text-overflow: -o-ellipsis-lastline;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 8;
        line-clamp: 8;
        -webkit-box-orient: vertical;
        height: 192px;
        max-height: 192px;
      }

      .more-button {
        margin-top: 50px;
        width: 122px;
        height: 43px;
        display: flex;
        justify-content: center;
        align-items: center;
        background: rgba(0, 0, 0, 0.8);
        font-size: 15px;
        color: #f1d9b0;
        border: 1px solid #f1d9b0;
        position: absolute;
        bottom: 4px;
        p {
          margin-bottom: 0;
        }
        span {
          display: inline-block;
          margin-top: -3px;
          margin-left: 10px;
        }
      }
    }
  }

}
  @media screen and (max-width: 768px) {
/*    .common-box { 
      .position-box {

        font-size: 18px;
        height: 90px;
        line-height: 90px;
        left: -5px;
      }
      .el-carousel__container {
        height: 300px!important;
      }
    }*/
  }


</style>